export default __webpack_public_path__ + "static/media/a2-4-2.5aa6f119.jpg";